import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const Password = ({ password, setPassword, disabled, name }) => {
  const { t: l } = useTranslation('loginAndRegister')

  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword((show) => !show)

  return (
      <TextField
        required
        fullWidth
        name="password"
        label={l('password')}
        type={showPassword ? 'text' : 'password'}
        id="password"
        autoComplete="current-password"
        size="small"
        value={password}
        disabled={disabled}
        style={{backgroundColor: disabled && "#f2f2f2"}}
        onChange={(event) => {
          setPassword(event.target.value)
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword} sx={{ p: 0 }}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
  )
}

export default Password
